











import { defineComponent, computed } from '@vue/composition-api';

const CommonGeolocationInput = defineComponent({
  setup(props: any) {
    const _value = computed(() => props.value);
    const rule = computed(() => {
      const text = _value?.value?.split(', ');
      if (!text[0]) return 'is:h';
      if (!text[1]) return 'is:h';
      if (parseInt(text[0], 10) > 90 || parseInt(text[0], 10) < -90) return 'is:h';
      if (parseInt(text[1], 10) > 180 || parseInt(text[1], 10) < -180) return 'is:h';
      return '';
    });

    return {
      rule,
      _value,
    };
  },
  props: {
    value: {
      type: String,
      default() { return ''; },
    },
    label: {
      type: String,
      default() { return 'ตำแหน่งที่ตั้ง (Google Map)'; },
    },
  },
});

export default CommonGeolocationInput;
